function Loader() {
  return (
    <div className="loader-conatiner">
      <div class="loader" id="loader"></div>
    </div>
  );
}

export default Loader